import { c as _c } from "react/compiler-runtime";
import type { NextApiError } from '@newfront-insurance/next-api-error';
import type { SWRResponse, SWRConfiguration } from 'swr';
import useSWR from 'swr';
import { useNextApiFetcher } from './config';
import { useNextApiBaseUrl } from './util';

/**
 * The SWR response from the Next API
 */
export type NextApiSubscription<T> = SWRResponse<T, NextApiError>;

/**
 * Make a GET request to the Next API. Returns a NextApiError if the response fails.
 * @param url Absolute API url, e.g. `/api/foo/bar`. The Next.js basePath will automatically be added.
 * @param options Fetching options
 */
export function useNextApiSubscription<T>(url: string | null, config?: SWRConfiguration): NextApiSubscription<T>;
export function useNextApiSubscription(url, config) {
  const $ = _c(3);
  const baseUrl = useNextApiBaseUrl();
  const fetcher = useNextApiFetcher();
  let t0;
  if ($[0] !== fetcher || $[1] !== url) {
    t0 = async function fetch() {
      if (url === null) {
        return null as T;
      }
      const {
        data,
        error
      } = await fetcher.request({
        url,
        method: "GET"
      });
      if (error) {
        throw error;
      }
      return data;
    };
    $[0] = fetcher;
    $[1] = url;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const fetch = t0;
  return useSWR(url === null ? null : `${baseUrl}${url}`, fetch, config);
}